var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useObjectStoreTemplatesStore } from "@/stores/objectStoreTemplatesStore";
import { hide } from "./services";
import InstanceDropdown from "@/components/ConfigTemplates/InstanceDropdown.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InstanceDropdown',
    props: {
        objectStore: null
    },
    emits: ["entryRemoved"],
    setup(__props, { emit }) {
        const props = __props;
        const objectStoreTemplatesStore = useObjectStoreTemplatesStore();
        const routeEdit = computed(() => `/object_store_instances/${props.objectStore.uuid}/edit`);
        const routeUpgrade = computed(() => `/object_store_instances/${props.objectStore.uuid}/upgrade`);
        const isUpgradable = computed(() => objectStoreTemplatesStore.canUpgrade(props.objectStore.template_id, props.objectStore.template_version));
        function onRemove() {
            return __awaiter(this, void 0, void 0, function* () {
                yield hide(props.objectStore);
                emit("entryRemoved");
            });
        }
        return { __sfc: true, objectStoreTemplatesStore, props, routeEdit, routeUpgrade, isUpgradable, onRemove, emit, InstanceDropdown };
    }
});
